import { ACTIONS } from './connectionUtils'
import type { User } from './loginUtils'

interface UsersResponse {
  success: boolean
  user?: User
  users?: User[]
  error?: string
}

async function getUsersList(user: string): Promise<UsersResponse> {
  try {
    const response = await fetch('/api/users', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        action: ACTIONS.GET,
        user,
      }),
    })
    const data: UsersResponse = await response.json()
    return data
  } catch (error) {
    console.error('Users error:', error)
    throw error
  }
}

async function insertUser(user: string, newUser: User) {
  try {
    const response = await fetch('/api/users', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        action: ACTIONS.INSERT,
        user,
        newUser,
      }),
    })
    return await response.json()
  } catch (error) {
    console.error('User error:', error)
    throw error
  }
}

async function updateUser(user: string, newUser: User) {
  try {
    const response = await fetch('/api/users', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        action: ACTIONS.UPDATE,
        user,
        newUser,
      }),
    })
    return await response.json()
  } catch (error) {
    console.error('User error:', error)
    throw error
  }
}

async function deleteUser(user: string, username: string) {
  try {
    const response = await fetch('/api/users', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        action: ACTIONS.DELETE,
        user,
        username,
      }),
    })
    return await response.json()
  } catch (error) {
    console.error('User error:', error)
    throw error
  }
}

const userChanged = (originalUser: User, newUser: User) => {
  return (
    originalUser.password !== newUser.password ||
    originalUser.telegram_chat_id !== newUser.telegram_chat_id ||
    originalUser.alerts !== newUser.alerts ||
    originalUser.admin !== newUser.admin
  )
}

export { getUsersList, insertUser, updateUser, deleteUser, userChanged }
